import { render, staticRenderFns } from "./yandex_map.vue?vue&type=template&id=7bd4df24&scoped=true&"
import script from "./yandex_map.vue?vue&type=script&lang=js&"
export * from "./yandex_map.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bd4df24",
  null
  
)

export default component.exports